// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3CbqX","signatureBlock":"Footer_signatureBlock__RAC3e","signature":"Footer_signature__3oirN"};